/**
 * Get SSR component markup by host id of CURRENT page.
 * @param id ID of the host component
 * @returns HTMLElement from SSR fragment
 */
export const getComponentMarkup = async (id: string, _window = self) => {
  const fragment = await _window.publicApi.getPageConfiguration();
  return fragment.getElementById(id);
};
